
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'StatisticsTabs',
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  });
